import React from 'react';
import './ReadingJobLink.css';
export default function ReadingJobLink({ job }) {
  return job && job.status !== 'fulfilled' ? <a className="reading-job-link" href={job.path} title="読んで稼ぐ" aria-label={`読んで稼ぐ：${job.title}`}>¥</a> : null;
}
